class ArticleCard extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const awcard = document.querySelectorAll('.aw-card');
        awcard.forEach(card => {
            const url = card.querySelector('.aw-url').getAttribute('href');
            const href = card.querySelectorAll('.aw-link');
            if (card) {
                href.forEach(element => {
                    element.addEventListener('click', (event) => {
                        event.preventDefault();
                        window.location.href = url;
                    });
                    element.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter') {
                            window.location.href = url;
                        }
                    });
                });
            }
        });
    }
}

customElements.define('article-card', ArticleCard)